// Thème aux couleurs de la charte Grainbow :
// violet #330072 (PANTONE 2685 C), bleu #303AB2 (2126 C), bleu vif #0072CE (285 C).
export type ThemeTokens = {
  mainBg: string;
  sidebarBg: string;
  activeNav: string;
  inactiveNav: string;
  cardBg: string;
  panelBg: string;
  text1: string;
  text2: string;
  text3: string;
  accent: string;
  btnBg: string;
  rowBorder: string;
  rowSel: string;
  inputBg: string;
  inputBorder: string;
  tagBg: string;
  tagColor: string;
  doneBg: string;
  doneColor: string;
  lateBg: string;
  lateColor: string;
  divider: string;
  tableHead: string;
};

export const lightTheme: ThemeTokens = {
  mainBg: "linear-gradient(165deg,#330072 0%,#303AB2 55%,#0072CE 100%)",
  sidebarBg: "#ffffff", activeNav: "#330072", inactiveNav: "#b4b2cc",
  cardBg: "#ffffff", panelBg: "#f7f7fd",
  text1: "#1a1726", text2: "#6b6882", text3: "#a09fba",
  accent: "#303AB2", btnBg: "#330072",
  rowBorder: "#eceafa", rowSel: "#f1efff",
  inputBg: "#f4f3fd", inputBorder: "#dfdcf2",
  tagBg: "#e7e9fb", tagColor: "#303AB2",
  doneBg: "#d1fae5", doneColor: "#059669",
  lateBg: "#fee2e2", lateColor: "#dc2626",
  divider: "#eceafa",
  tableHead: "#f3f2fc",
};

export const darkTheme: ThemeTokens = {
  mainBg: "linear-gradient(165deg,#140028 0%,#151243 55%,#002846 100%)",
  sidebarBg: "#0f0d1a", activeNav: "#303AB2", inactiveNav: "#6b6882",
  cardBg: "#1d1a2f", panelBg: "#19172a",
  text1: "#f0eeff", text2: "#8e8aab", text3: "#5c596e",
  accent: "#7f8bff", btnBg: "#303AB2",
  rowBorder: "rgba(255,255,255,0.07)", rowSel: "rgba(48,58,178,0.2)",
  inputBg: "#2a2640", inputBorder: "rgba(255,255,255,0.1)",
  tagBg: "rgba(48,58,178,0.3)", tagColor: "#9fa8ff",
  doneBg: "rgba(16,185,129,0.15)", doneColor: "#34d399",
  lateBg: "rgba(239,68,68,0.15)", lateColor: "#f87171",
  divider: "rgba(255,255,255,0.07)",
  tableHead: "#252240",
};
